import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import register from '@/components/register'
import passwordForget from '@/components/passwordForget'
import container from '@/components/container'
import home from '@/components/home'



import commomArea from '@/components/device/commomArea'
import apartmentRoomDetail from '@/components/device/apartmentRoomDetail'
import deviceApartmentList from '@/components/device/deviceApartmentList'
import deviceApartmentDetail from '@/components/device/deviceApartmentDetail'
import apartmentRoomList from '@/components/device/apartmentRoomList'
import deviceApartmentTabs from '@/components/device/deviceApartmentTabs'
import apartmentList from '@/components/apartment/apartmentList'
import apartmentDetail from '@/components/apartment/apartmentDetail'
import apartmentTabs from '@/components/apartment/apartmentTabs'
import roleList from '@/components/butler/roleList'
import butlerList from '@/components/butler/butlerList'
import tenantList from '@/components/tenant/tenantList'
import tenantTabs from '@/components/tenant/tenantTabs'
import worksheetList from '@/components/worksheet/worksheetList'
import systemRecord from '@/components/systemRecord'
import deviceStaList from '@/components/statistics/deviceStaList'
import roomStaList from '@/components/statistics/roomStaList'
import deviceStaDetail from '@/components/statistics/deviceStaDetail'
import deviceList from '@/components/deviceManage/deviceList'
import fingerprintList from '@/components/fingerprintManage/fingerprintList'
import roomList from '@/components/room/roomList'
import checkInMoreRoom from '@/components/room/checkInMoreRoom'
import roomDetail from '@/components/room/roomDetail'
import deviceAuth from '@/components/deviceManage/deviceAuth'
import openRecord from '@/components/openRecord'
import alarmRecord from '@/components/alarmRecord'
import tenantDetail from '@/components/tenant/tenantDetail'
import buildingList from '@/components/building/buildingList'
import buildingDetail from '@/components/building/buildingDetail'
import analysisOpenRecord from '@/components/analysisOpenRecord'
import ekeyList from '@/components/app/ekeyList'
import me from '@/components/app/me'
import groupList from '@/components/butler/groupList'


Vue.use(Router)

export default new Router({
  // mode: 'hash',
  routes: [
    {
      path: '/',
      // name: 'login',
      component: login,
      meta: {
        // 页面标题title
        title:""
      }
    },
    {
      path: '/register',
      // name: 'login',
      component: register
    },
    {
      path: '/passwordForget',
      // name: 'login',
      component: passwordForget
    },
    {
      path: '/ekeyList',
      // name: 'login',
      component: ekeyList
    },
    {
      path: '/me',
      // name: 'login',
      component: me
    },
    {
       path: '/container',
      //  name:'container',
       component:container,
       children: [
        {path:'/',redirect:'/home'},
        {path: '/home', name: 'index.index', component: home},
        {path: '/deviceApartmentTabs', name: 'container.roomManage', component: deviceApartmentTabs},
        {path: '/apartmentTabs', name: 'index.apartmentList', component: apartmentTabs},
        {path: '/roleList', name: 'index.roleList', component: roleList},
        {path: '/butlerList', name: 'index.butlerList', component: butlerList},
        {path: '/tenantTabs', name: 'index.tenantList', component: tenantTabs},
        {path: '/worksheetList', name: 'index.workOrder', component: worksheetList},
        {path: '/systemRecord', name: 'index.operateRecord', component: systemRecord},
        {path: '/deviceStaList', name: 'index.deviceStatistics', component: deviceStaList},
        {path: '/roomStaList', name: 'index.roomStatistics', component: roomStaList},
        {path: '/deviceStaDetail', name: 'index.deviceStaDetail', component: deviceStaDetail},
        {path: '/deviceList', name: 'container.deviceManage', component: deviceList},
        {path: '/fingerprintList', name: 'container.fingerprintManage', component: fingerprintList},      
        {path: '/roomList', name: 'index.roomManage', component: roomList,meta:{keepAlive: true}},
        {path: '/roomDetail', name: 'index.roomDetail', component: roomDetail},
        {path: '/checkInMoreRoom', name: 'index.batchCheckInRoom', component: checkInMoreRoom},
        {path: '/deviceAuth', name: 'index.lockAuth', component: deviceAuth},
        {path: '/openRecord', name: 'index.openRecord', component: openRecord},
        {path: '/alarmRecord', name: 'index.alarmRecord', component: alarmRecord},
        {path: '/tenantDetail', name: 'tenant.tenantDetail', component: tenantDetail},
        {path: '/tenantList', name: 'index.tenantList', component: tenantList},
        {path: '/buildingList', name: 'commom.buildingList', component: buildingList},
        {path: '/buildingDetail', name: 'commom.buildingDetail', component: buildingDetail},
        {path: '/analysisOpenRecord', name: 'commom.kmcsfx', component: analysisOpenRecord},
        {path: '/groupList', name: 'groupList.group', component: groupList},
      ]
    }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js